import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  templateUrl: './delegate.component.html',
  styleUrls: ['./delegate.component.css'],
})
export class DelegateComponent {

  constructor() {
  }

}
